export default [
  {
    path: "indicatorsReport",
    name: "indicators-report",
    component: () =>
      import("@/views/reports/indicatorsReport/IndicatorsReport.vue"),
  },
  {
    path: "indicatorsReport/excludedFlights",
    name: "excluded-flights",
    component: () =>
      import("@/views/reports/indicatorsReport/ExcludedFlights.vue"),
  },
  {
    path: "apiRequestReport/ApiRequestReport",
    name: "api-request-report",
    component: () =>
      import("@/views/reports/apiRequestReport/ApiRequestReport.vue"),
  },
  {
    path: "indicatorsEmbarqueReport",
    name: "indicators-embarque-report",
    component: () =>
      import("@/views/reports/indicatorsReport/IndicatorsEmbarqueReport.vue"),
  },
  {
    path: "graphicIndicatorsEmbarqueReport",
    name: "graphic-indicators-embarque-report",
    component: () =>
      import(
        "@/views/reports/indicatorsReport/GraphicIndicatorsEmbarqueReport.vue"
      ),
  },
  {
    path: "graphicIndicatorsApiReport",
    name: "graphic-indicators-api-report",
    component: () =>
      import(
        "@/views/reports/graphicIndicatorsApiReport/GraphicIndicatorsApiReport.vue"
      ),
  },
];
